// extracted by mini-css-extract-plugin
export default {"close":"ReversedAccordion_close__+j5O6"};